module.exports = __webpack_public_path__ + "static/media/003-emoji-2.d310fc7a.svg";